<ion-modal #placeBetModal id="place-bet-modal" [isOpen]="true" (didDismiss)="afterModalDismissal()" xmlns="http://www.w3.org/1999/html">
	<ng-template>
		<form
			[formGroup]="placeBetForm"
			(ngSubmit)="placeBet()"
			class="py-3 px-2 flex flex-col gap-1 justify-start items-start w-full"
			[ngClass]="{ back: selectedRunner().side === 'BACK', lay: selectedRunner().side === 'LAY' }">
			<div class="w-full flex justify-between items-center gap-2">
				<p class="text-base font-bold">
					{{ sideLabel(selectedRunner().side) }} - {{ selectedRunner().name }} {{ selectedRunner().handicapLabel }}
					<span class="font-normal">({{ selectedRunner().oddMarketName }})</span>
				</p>
				<ion-button shape="round" fill="clear" (click)="placeBetModal.dismiss()" class="w-fit">
					<ion-icon name="close-circle-outline" size="large" color="dark" slot="icon-only"></ion-icon>
				</ion-button>
			</div>

			<span class="w-full h-0.5 bg-(--ion-color-primary) my-1.5 rounded-full"></span>

			<p class="w-full text-sm text-center">
				{{ (selectedRunner().side === 'BACK' ? 'Profit' : 'Liability') | translate }}: {{ profitOrLiability() | number: '1.0-2' }}
			</p>

			<div class="w-full flex justify-between items-center py-1.5 gap-2">
				<div class="flex justify-start items-center h-8 gap-1 w-[35%]">
					<button
						type="button"
						class="h-8 md:h-full flex justify-center items-center aspect-square text-2xl font-light m-0 p-0 bg-(--ion-color-medium) mini-button"
						[disabled]="shouldOddBeReadonly"
						(click)="decrementOddByAmount()">
						<ion-icon name="remove"></ion-icon>
					</button>
					<input
						type="number"
						class="w-full h-8 md:h-full flex-grow bg-(--ion-color-light) text-(--ion-color-dark) text-sm text-center font-bold border-[1.5px] border-black rounded-sm"
						formControlName="odd"
						[placeholder]="'Odd' | translate"
						[readonly]="shouldOddBeReadonly" />
					<button
						type="button"
						class="h-8 md:h-full flex justify-center items-center aspect-square text-2xl font-light m-0 p-0 bg-(--ion-color-medium) mini-button"
						[disabled]="shouldOddBeReadonly"
						(click)="incrementOddByAmount()">
						<ion-icon name="add"></ion-icon>
					</button>
				</div>
				<input
					type="number"
					class="w-[63%] h-8 bg-(--ion-color-light) text-(--ion-color-dark) placeholder:text-gray-500 text-sm text-center font-bold border-[1.5px] border-black rounded-sm"
					formControlName="stake"
					[placeholder]="'Stake' | translate" />
			</div>
			<div class="w-full flex justify-between items-center py-1">
				<div class="w-1/2 flex justify-start items-center">
					@if (formControls.odd.errors) {
						<app-form-error-message [control]="formControls.odd" />
					}
				</div>
				<div class="w-1/2 flex justify-end items-center">
					@if ((formControls.stake.dirty || formControls.stake.touched) && formControls.stake.errors) {
						<app-form-error-message [control]="formControls.stake" />
					}
					@if (errorMessage) {
						<span class="text-red-600 text-[0.813rem]">{{ errorMessage | translate }}</span>
					}
				</div>
			</div>

			<div class="w-full flex flex-wrap items-center gap-1 py-1">
				@for (stake of editStakeModalService.quickBetAmounts$ | async; track stake) {
					<button class="grow" type="button" (click)="setStakeAmount(stake)">
						<div class="grow py-0.5 px-0 border-[1.5px] border-black rounded-sm text-sm text-center font-bold bg-(--ion-color-medium)">
							{{ formatQuickAmount(stake) }}
						</div>
					</button>
				}
			</div>

			@if (isHandicapTypeMarket) {
				<div class="w-full">
					<app-ah-ladder-pnl />
				</div>
			}

			<div class="flex flex-col justify-start items-start" *appFeatureFlag="'exposureCalculation'">
				<ion-button size="small" color="medium" (click)="showDebuggingAlert()">Debug</ion-button>
				<p class="text-(--ion-color-dark) p-0 mt-1 text-sm">New Total Exposure: {{ getTotalExposureDebugging() | number: '1.0-2' }}</p>
			</div>

			<span class="w-full h-0.5 bg-(--ion-color-primary) my-1.5 rounded-full"></span>

			<div class="w-full flex items-center pt-1 pb-1.5 gap-3">
				<div class="w-1/2">
					<button type="button" class="big-button bg-(--ion-color-medium)" [disabled]="betService.isPlacingBet()" (click)="placeBetModal.dismiss()">
						{{ 'Cancel' | translate }}
					</button>
				</div>
				<div class="w-1/2">
					<button
						[disabled]="
							placeBetForm.invalid ||
							betService.isPlacingBet() ||
							isPlacingInAnotherTab ||
							insufficientBalanceError() ||
							shouldCancelUnmatchedBetsFirst()
						"
						class="big-button bg-(--ion-color-primary) text-(--ion-color-primary-contrast) disabled:opacity-60"
						type="submit">
						@if (betService.isPlacingBet() || isPlacingInAnotherTab) {
							<ion-spinner />
						} @else {
							<span>{{ 'Place Bet' | translate }}</span>
						}
					</button>
				</div>
			</div>
		</form>
	</ng-template>
</ion-modal>
